import { render } from "./dialog-coupont.vue?vue&type=template&id=2b754d6c&scoped=true&ts=true"
import script from "./dialog-coupont.vue?vue&type=script&lang=ts"
export * from "./dialog-coupont.vue?vue&type=script&lang=ts"

import "./dialog-coupont.vue?vue&type=style&index=0&id=2b754d6c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b754d6c"]])

export default __exports__